Object.defineProperty(exports,"__esModule",{value:true});var _material=require("./material");var _material2=_interopRequireDefault(_material);
var _grayscale=require("./grayscale");var _grayscale2=_interopRequireDefault(_grayscale);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

{
material:_material2.default,
grayscale:_grayscale2.default};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-theme/victory-theme.js
// module id = 272
// module chunks = 0